export default __webpack_public_path__ + "img/sign-out.389aadb7.svg";